import React, { ReactElement, SVGProps } from 'react'
import BaseIcon from "./BaseIcon";

export default function ShiftIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox="0 0 16 16">
      <path d="M6.126 12.556v-3.8H4.552q-.352 0-.496-.305a.51.51 0 0 1 .075-.577l3.745-4.572a.51.51 0 0 1 .42-.204q.259 0 .421.204l3.745 4.572q.217.272.075.577t-.496.305h-1.573v3.8a.53.53 0 0 1-.156.386.53.53 0 0 1-.387.156H6.668a.53.53 0 0 1-.386-.156.53.53 0 0 1-.156-.386"
        fill="currentColor"
      />
    </BaseIcon>
  )
}
